/** Track-aware guard: locks only the "tronc-commun" track when access flag is off. */
import { useParams } from "react-router-dom";
import { usePortalAccess } from "../../contexts/PortalAccessContext";
import AccessLockedScreen from "./AccessLockedScreen";

export default function TrackAccessGuard({ children }) {
  const { track } = useParams();
  const { access, loading } = usePortalAccess();
  if (loading) return null;
  if (track === "tronc-commun" && !access.tronc_commun) {
    return (
      <AccessLockedScreen
        testId="tronc-commun-locked"
        titleKey="portal.locked.tronc_commun_title"
        messageKey="portal.locked.tronc_commun_msg"
      />
    );
  }
  return children;
}
